module.exports = __webpack_public_path__ + "static/media/tamkeen_logo.559bd0fe.png";